<template>
	<div>
		<eg-modal :show="show" @close="$emit('close', false)">
			<p class="center" slot="header">
				<b>
					Este fornecedor ainda não disponibilizou seus documentos.
					Para verificá-los nos envie uma solicitação.</b
				>
			</p>
			<div slot="body" class="input-field">
				<eg-input
					:value="observations"
					v-model="observations"
					placeholder-text="Digite aqui o que você deseja"
					background-color="#FFF"
				/>
				<!-- <input
				id="request-public-documents-observations"
				type="text"
				name="request-public-documents-observations"
				placeholder="Digite aqui o que você deseja."
			/> -->
			</div>

			<div slot="footer">
				<a
					id="request-public-documents"
					@click="postPublicDocuments()"
					class="modal-action modal-close btn yellow bold-text capitalize-first-letter-text request-public-documents"
					>Solicitar documentos</a
				>
			</div>
		</eg-modal>
		<eg-modal :show="sucess" @close="sucess = false">
			<p slot="body">Solicitação recebida com sucesso</p>
		</eg-modal>
	</div>
</template>

<script>
// requisições
import {postPublicDocuments} from '@/services/api/supplier';
export default {
    name: 'requestPublicDocuments',
    data: () => ({
        observations: '',
        sucess: false,
    }),
    props: {
        show: Boolean,
        supplier: Object,
        competitionData: Object,
    },
    methods: {
        async postPublicDocuments() {
            const payload = {
                quotation: this.competitionData.id,
                supplier: this.supplier.id,
                supplier_trading_name: this.supplier.name,
                observations: this.observations,
            };
            await postPublicDocuments(payload);
            this.$emit('close', false);
            this.sucess = true;
        },
    },
};
</script>

<style></style>
